import { useLazyQuery } from "@apollo/client"
import { REPORT_USER_LIST, REPORT_STORE_TOURNAMENTS } from "../queries/reports"

export interface ReportFilters {
  gamesIds: number[]
  dates: {
    start: string
    end: string
  }
  location: {
    countryId: number
    regionId: number
    locationId: number
  }
  tournamentTypesIds: number[]
  storesIds: number[]
  limit: number
}

export interface ReportPerson {
  id: number
  name: string
  firstSurname: string
  lastSurname: string
  email: string
  code: string
  playedTournaments: number
  emailValid: boolean
  documentNumber?: string
  documentNumberType?: number
  Address?: {
    countryId: number
    regionId: number
    locationId: number
  }
  Tournaments?: {
    id: number
    tournamentId: number
    raceId: number
    points: number
    Tournament: {
      id: number
      name: string
      gameId: number
      storeId: number
    }
  }[]
}

export interface ReportTournament {
  id: number
  name: string
  storeId: number
  startDate: string
  urlView: string
  gameId: number
  typeId: number
  statusId: number
  formatId: number
  TournamentPlayers?: {
    id: number
    personId: number
    raceId: number
    points: number
    Person: {
      id: number
      name: string
      firstSurname: string
      lastSurname: string
      email: string
      code: string
      emailValid: boolean
    }
  }[]
}

export const useReportUserList = () => {
  const [fetchReport, { data, loading, error }] = useLazyQuery<{
    ReportUserList: {
      status: {
        success: boolean
        name: string
        detail: string
        code: number
      }
      Persons: ReportPerson[]
    }
  }>(REPORT_USER_LIST, {
    fetchPolicy: "network-only",
  })

  const executeReport = async (filters: ReportFilters) => {
    const result = await fetchReport({
      variables: {
        ReportUserListInput: {
          filters,
        },
      },
    })
    return result
  }

  return {
    executeReport,
    persons: data?.ReportUserList?.Persons || [],
    status: data?.ReportUserList?.status,
    loading,
    error,
  }
}

export const useReportStoreTournaments = () => {
  const [fetchReport, { data, loading, error }] = useLazyQuery<{
    ReportStoreTournaments: {
      status: {
        success: boolean
        name: string
        detail: string
        code: number
      }
      Tournaments: ReportTournament[]
    }
  }>(REPORT_STORE_TOURNAMENTS, {
    fetchPolicy: "network-only",
  })

  const executeReport = async (filters: ReportFilters) => {
    const result = await fetchReport({
      variables: {
        ReportStoreTournamentsInput: {
          filters,
        },
      },
    })
    return result
  }

  return {
    executeReport,
    tournaments: data?.ReportStoreTournaments?.Tournaments || [],
    status: data?.ReportStoreTournaments?.status,
    loading,
    error,
  }
}
